export default Object.freeze({
	cancelaccountdowngrade: {
		flagName: 'grow-411__stamps_com_retention_plans__4_99_vs__9_99',
		experimentKey: 'plan_100',
	},
});
